import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isSinapsisTestBusiness } from '@core/constants/sinapsis-business.constant';
import { CompanyService } from '@features/company/services/company.service';
import { map } from 'rxjs';

/**
 * @description
 * Permite la ruta solo si el negocio tiene habilitada la modalidad de mantenimiento
 * avanzado (`businesses/sitemaps/advance-maintenance`). Si está deshabilitada, redirige
 * a `data.redirectWhenDisabled` o `data.backFallback`.
 *
 * El negocio Sinapsis de pruebas siempre tiene acceso a ambas modalidades.
 */
export const advancedMaintenanceEnabledGuard: CanActivateFn = (route) => {
  const companyService = inject(CompanyService);
  const router = inject(Router);

  if (isSinapsisTestBusiness(companyService.business)) {
    return true;
  }

  const redirectTo =
    (route.data['redirectWhenDisabled'] as string | undefined) ??
    (route.data['backFallback'] as string | undefined) ??
    '/home';
  const redirectTree = router.parseUrl(redirectTo);

  const businessId = companyService.business?.id ?? companyService.businessId();
  if (!businessId) {
    return redirectTree;
  }

  return companyService.ensureAdvanceMaintenanceLoaded(businessId).pipe(
    map((config) =>
      (config?.advanceMaintenance ?? companyService.advancedMaintenanceEnabled())
        ? true
        : redirectTree,
    ),
  );
};
